import { render, staticRenderFns } from "./IconPrint.vue?vue&type=template&id=13235b4a&functional=true&"
import script from "./IconPrint.vue?vue&type=script&lang=js&"
export * from "./IconPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports